import { motion } from "framer-motion";
import { Sun, Zap, Snowflake } from "lucide-react";

const CoreValues = () => {
  const coreValues = [
    {
      title: "Our Mission",
      description:
        "To empower organizations with exceptional technology talent while creating life-changing career opportunities for IT professionals worldwide.",
      icon: Sun,
    },
    {
      title: "Our Vision",
      description:
        "To be the most trusted and innovative technology staffing company globally — known for speed, quality, and lasting partnerships.",
      icon: Zap,
    },
    {
      title: "Our Approach",
      description:
        "Our team combines industry knowledge, recruitment expertise, and a people-first approach to ensure every hiring engagement delivers long-term value for both clients and candidates.",
      icon: Snowflake,
    },
  ];

  return (
    <section className="py-16 px-[5%] xl:px-[8%] bg-[#001534] w-full overflow-hidden font-sans">
      <div className="w-full max-w-[1440px] mx-auto">
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 lg:mb-12"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#ffffff] font-semibold leading-tight tracking-tight">
            Our Core Values
          </h2>
        </motion.div>

        {/* Values Columns Container */}
        <div className="flex flex-col lg:flex-row lg:items-stretch w-full">
          {coreValues.map((value, i) => {
            const isLast = i === coreValues.length - 1;
            const isFirst = i === 0;

            return (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.15, duration: 0.6 }}
                className={`flex-1 flex flex-col 
                  ${
                    !isLast
                      ? "border-b lg:border-b-0 lg:border-r border-[#ffffff] pb-12 lg:pb-0 mb-12 lg:mb-0 lg:pr-10"
                      : ""
                  } 
                  ${!isFirst ? "lg:pl-10" : ""}
                `}
              >
                {/* Icon */}
                <div className="w-12 h-12 flex items-center justify-start text-[#ffffff] mb-6 xl:mb-8">
                  <value.icon strokeWidth={1.5} size={36} />
                </div>

                {/* Content */}
                <h3 className="text-[22px] xl:text-[24px] font-semibold text-[#ffffff] mb-4">
                  {value.title}
                </h3>
                <p className="text-[#ffffff] text-[15px] xl:text-[16px] leading-[1.6]">
                  {value.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;